import { BaseFetch } from "../main-model";
export default class StaffModel extends BaseFetch {
  getStaffBy = (data) =>
    this.authFetch({
      url: "staff/getStaffBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getNumberStaffBy = (data) =>
    this.authFetch({
      url: "staff/getNumberStaffBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getStaffById = (data) =>
    this.authFetch({
      url: "staff/getStaffById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStaffById = (data) =>
    this.authFetch({
      url: "staff/updateStaffById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertStaff = (data) =>
    this.authFetch({
      url: "staff/insertStaff",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertUploadStaff = (data) =>
    this.authFetch({
      url: "staff/insertUploadStaff",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteStaffById = (data) =>
    this.authFetch({
      url: "staff/deleteStaffById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertStaffRegalia = (data) =>
    this.authFetch({
      url: "staff/insertStaffRegalia",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStaffRegaliaById = (data) =>
    this.authFetch({
      url: "staff/updateStaffRegaliaById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
